import { useMemo } from "react";
import {
  useServiceLocator,
  type ServiceMap,
} from "@/shared/providers/service-locator";

/**
 * Hook to get a service instance by name
 *
 * @example
 * ```tsx
 * const authSvc = useService('auth');
 * await authSvc.updatePassword({ ... });
 * ```
 */
export const useService = <T extends keyof ServiceMap>(
  name: T
): ServiceMap[T] => {
  const { services } = useServiceLocator();
  return useMemo(() => services[name], [services, name]);
};
